module.exports = __webpack_public_path__ + "img/shangtang-propa.8e8a48a1.png";